import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";

import "react-toastify/dist/ReactToastify.css";

const SendSMS = () => {
  const location = useLocation();
  const [mobile, setMobile] = useState("");
  const [message, setMessage] = useState("");
  const [invAmt, setInvAmt] = useState("100");
  const [branch, setBranch] = useState("8");
  const [grnNums, setGrnNums] = useState("80");
  const [supid, setSupid] = useState("5");
  const [brid, setBrid] = useState("8");
  const [loginuserid, setLoginuserid] = useState("7");

  const { isDark, skin } = useContext(ThemeContext);
const currentSkin =getCurrentSkin(skin)
  const { baseColor, baseShade } = currentSkin;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const itemCode = params.get("itemCode") || "N/A";
    const itemName = params.get("itemName") || "Unknown";
    const generatedMessage = `Item Name: ${itemName} - Item Code: ${itemCode}, Successfully from Nissi Infotech on ${new Date().toLocaleString()}`;
    setMessage(generatedMessage);
  }, [location]);

  const handleSend = async () => {
    if (!/^\d{10}$/.test(mobile)) {
      toast.warning("Please enter a valid 10-digit mobile number.");
      return;
    }

    const payload = {
      mobile: mobile.trim(),
      message: message.trim(),
      invAmt: invAmt.trim(),
      branch: branch.trim(),
      grnNums: grnNums.trim(),
      supid: supid.trim(),
      brid: brid.trim(),
      loginuserid: loginuserid.trim(),
    };

    try {
      const res = await axios.post("http://nissi-india.com/api/sms/send-sms", payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (res.data?.success) {
        toast.success("✅ SMS sent successfully!");
      } else {
        toast.error(res.data?.message || "Failed to send SMS.");
      }
    } catch (err) {
      console.error("❌ SMS error:", err);
      toast.error("Unexpected error. See console for details.");
    }
  };

  return (
    <LayoutWrapper>
      <HeaderBar title="Send SMS Notification" />

      <div
        className={`p-6 rounded-2xl shadow-xl border mt-6 ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white ${currentSkin.glass} text-black`
        }`}
      >
        <h2 className="text-2xl font-semibold text-blue-700 mb-6">📩 SMS Sender</h2>

        {/* Mobile Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">
            Mobile Number <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg"
            placeholder="Enter 10-digit mobile number"
          />
        </div>

        {/* Message Box */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-1">Generated Message</label>
          <textarea
            readOnly
            value={message}
            rows={4}
            className="w-full px-4 py-2 border rounded-lg bg-gray-100"
          />
        </div>

        {/* Additional Fields Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          <input
            className="px-3 py-2 border rounded"
            placeholder="invAmt"
            value={invAmt}
            onChange={(e) => setInvAmt(e.target.value)}
          />
          <input
            className="px-3 py-2 border rounded"
            placeholder="branch"
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
          />
          <input
            className="px-3 py-2 border rounded"
            placeholder="grnNums"
            value={grnNums}
            onChange={(e) => setGrnNums(e.target.value)}
          />
          <input
            className="px-3 py-2 border rounded"
            placeholder="supid"
            value={supid}
            onChange={(e) => setSupid(e.target.value)}
          />
          <input
            className="px-3 py-2 border rounded"
            placeholder="brid"
            value={brid}
            onChange={(e) => setBrid(e.target.value)}
          />
          <input
            className="px-3 py-2 border rounded"
            placeholder="loginuserid"
            value={loginuserid}
            onChange={(e) => setLoginuserid(e.target.value)}
          />
        </div>

        {/* Action Button */}
        <button
          onClick={handleSend}
          className={`px-6 py-2 text-white rounded shadow bg-${baseColor}-${baseShade} hover:bg-${baseColor}-700 transition`}
        >
          🚀 Send SMS
        </button>
      </div>

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </LayoutWrapper>
  );
};

export default SendSMS;
